import actionTypes from './actiontypes';
import config from '../../../config/config';

const {
  REQUEST_ACTIVITY_LOGS,
  RECEIVE_ACTIVITY_LOGS,
  SERVER_ERROR_OCURED,
  CLEAR_ERRORS,
  FILTER_LOGS
} = actionTypes;

function hasErrored(errors) {
  return {
    type: SERVER_ERROR_OCURED,
    errors: errors
  };
}

export function filterLogs(conference, webinar, startDate, endDate, keyword) {
  return function(dispatch) { 
    dispatch({
      type: FILTER_LOGS,
      conference, webinar, startDate, endDate, keyword
    });
  }
}

export function fetchActivityLogs(token) {
  return function(dispatch) {
    dispatch({ type: REQUEST_ACTIVITY_LOGS });
    return fetch(`${config.URI}/api/v1/activity_logs`, {
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText);
        } else {
          return res.json();
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          if(res.data && res.data.activity_logs.length > 0) {
            res.data.activity_logs = res.data.activity_logs.map(log => {
              log.show = true;
              return log;
            })
          }
          dispatch({ type: RECEIVE_ACTIVITY_LOGS, activityLogs: res.data.activity_logs });
        } else if (res.errors) {
          console.error(res.errors);
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        
        console.error(error)
      });
  };
}

export function clearErrors() {
  return function(dispatch) { 
    dispatch({ type: CLEAR_ERRORS });
  }
 
}




// WEBPACK FOOTER //
// src/routes/ActivityLogs/actions/index.js